import React from "react";
import { SmileOutlined } from "@ant-design/icons";
import { Result } from "antd";

const ExternalRedirectPage = () => {
  return (
    <div>
      <Result
        icon={<SmileOutlined />}
        title="You can now close this window. The link has opened in an external browser."
      />
    </div>
  );
};

export default ExternalRedirectPage;
